import Schema, { optional } from 'AppReact/schema';
import { option } from 'types/inspectionTemplate';

const ref = {
  current: optional('string'),
};

export default {
  selectedOptions: Schema(option, 'array', { defaultValue: [] }),
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  item: Schema({}, 'object', { defaultValue: [] }),
  openOnTop: Schema('boolean', 'primitive-nullable', { defaultValue: null }),
  containerRef: Schema(ref, 'object', { defaultValue: { current: null } }),
  hasCharges: Schema('boolean', 'primitive-nullable', { defaultValue: null }),
}